export const notificationSettingsUrl = '/my-account/profile/notification-settings.html';

export const LS_HAS_BUYER_SEEN_MODAL_KEY = 'favouritesConnectBuyerModalSeen';
export const LS_HAS_SELLER_SEEN_MODAL_KEY = 'favouritesConnectSellerModalSeen';
